export default __webpack_public_path__ + "static/avatar-kayi-sketch-1-detail-94d83ff7e4d97f10e88311c3a27c0b17.png";